interface PublicUrls {
  home?: string | null;
  catalogue?: string | null;
}

export function resolvePublicHome(cmsEnabled: boolean, urls?: PublicUrls | null) {
  if (cmsEnabled) return '/web/#home';
  return urls?.home || urls?.catalogue || '/eshop/catalogue';
}
